import {useEffect,useState} from 'react';
import { FiMail } from "react-icons/fi";
import Navbar from 'react-bootstrap/Navbar';
import Logo from './Logo';
import Menu from './Menu';
import ContactEmail from './ContactEmail';
import { FaPhone } from 'react-icons/fa6';
import AnchorLink from '../AnchorLink';


const menu = [
    {
        id:1,
        name:'Home',
        target:"_self",
        url:'/'
    },
    {
        id:2,
        name:'Services',
        target:"_self",
        url:'/services',
        submenu:[
            {
                id:1,
                name:'Design',
                target:"_self",
                url:'/services/design'
            },
            {
                id:2,
                name:'Development',
                target:"_self",
                url:'/services/development'
            },
            {
                id:3,
                name:'ECommerce',
                target:"_self",
                url:'/services/e-commerce'
            },
            {
                id:4,
                name:'Mobile Apps',
                target:"_self",
                url:'/services/mobile-apps'
            },
            {
                id:5,
                name:'Technology',
                target:"_self",
                url:'/services/technology'
            },
            {
                id:6,
                name:'Full Stack',
                target:"_self",
                url:'/services/full-stack'
            }
        ],
        url:'#!'
    },
    {
        id:3,
        name:'About Us',
        target:"_self",
        url:'/about-us'
    },
    {
        id:4,
        name:'Solution',
        target:"_self",
        url:'/'
    },
    {
        id:5,
        name:'Our Reviews',
        target:"_self",
        url:'/reviews'
    },
    {
        id:6,
        name:'Contact Us',
        target:"_self",
        url:'/contact'
    }
]

const Header = () => {  

    const [animateHeader, setAnimateHeader] = useState('')  

    const scrollEffect = () => {
        if (window.scrollY > 140) {
        setAnimateHeader('animate-header');
        } else {
        setAnimateHeader('');
        }
    }

    useEffect(() =>{
        window.addEventListener("scroll", scrollEffect); 

        return() =>{
            window.removeEventListener("scroll", scrollEffect);
        }
    },[])
    return (
        <header className={`position-fixed w-100 ${animateHeader}`}>
            <Navbar expand="xl" className={`navbar position-relative py-0 px-0 px-lg-4 ${animateHeader}`}>
                <Logo />
                
                <Menu 
                    menu={menu}
                />

                <ContactEmail 
                    icon={<FiMail size={20} className='me-2'/>}
                    email={'dummyuser@dummy.com'}
                />
                <div>
                    <AnchorLink
                        href={"tel:000000000"}
                        className='btn btn-primary contact-us-btn'
                        icon={<FaPhone className="phone-icon" size={20}/>}
                        title={'000000000'}
                    />
                </div>               
            </Navbar>
        </header>
    );
};

export default Header;